export const UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES = 'UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES'
export const UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES_FAILED = 'UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES_FAILED'
export const UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES_SUCCESS = 'UPDATE_BATCH_REGULAR_UNAVAILABLE_TIMES_SUCCESS'
